<template>
    <div class="row">
        <div class="col-lg-10">
            <ul class="nav nav-tabs  m-tabs-line" role="tablist">
                <li class="nav-item m-tabs__item" v-for="(value, key, index) in panels" v-bind:key="key">
                    <a class="nav-link m-tabs__link show" v-bind:class="{'active' : (index == 0)}"
                       data-toggle="tab" v-bind:href="'#m_tabs_6_'+slugify(key)" role="tab" aria-selected="true" @click="setActivePanel(key)">
                        {{key}}
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane show" v-bind:class="{'active' : (index == 0)}"
                     v-bind:id="'m_tabs_6_'+slugify(key)" role="tabpanel" v-for="(value, key, index) in panels"
                     v-bind:key="key">
                    <div class="row">
                        <div class="col-12">
                            <button type="button" @click="renameModal(key)"><i  class="fa fa-edit"></i></button>
                            <button type="button" @click="deletePanel(key)"><i  class="fa fa-trash"></i></button>
                        </div>
                    </div>
                    <button type="button" @click="addRow">Add Row</button>
                    <button type="button" @click="addBreak">Add Break</button>
                    <div class="row" v-for="(row_value, row_key) in getRow(value)" v-bind:key="row_key"
                         v-if="row_value.break != 1">
                        <div class="col-12">
                            <button type="button" @click="addCol('col-md-3',row_key)">Add Col-3</button>
                            <button type="button" @click="addCol('col-md-4',row_key)">Add Col-4</button>
                            <button type="button" @click="addCol('col-md-6',row_key)">Add Col-6</button>
                            <button type="button" @click="addCol('col-md-12',row_key)">Add Col-12</button>
                            <button type="button" @click="deleteRow(row_key)"><i  class="fa fa-trash"></i></button>
                        </div>
                        <div v-for="(value4, key4) in row_value" :class="getClass(value4)" style="min-height: 200px; border: 1px black dotted;"
                             v-bind:key="key4">
                            <div class="row">
                                <div class="col-12">
                                    <button type="button" @click="addInput(key4, getClass(value4), row_key)">Add Input</button>
                                    <button type="button" @click="deleteCol(key4, row_key)"><i  class="fa fa-trash"></i></button>
                                </div>
                            </div>
                            <span v-for="(item, keyx) in getElements(value4)" v-bind:key="keyx">
                                <FormGroupComponent
                                        :key="item.name"
                                        v-bind:label="item.label"
                                        v-bind:placeholder="item.placeholder"
                                        v-bind:id="item.id"
                                        v-bind:helpText="item.helpText"
                                        v-bind:name="item.name"
                                        v-bind:type="item.type"
                                        v-bind:has-danger="item.hasDanger"
                                        v-bind:error-message="errorMessage"
                                        v-bind:viewStyle="item.viewStyle"
                                        v-bind:inputClass="item.class"
                                        v-bind:options="item.options">
                                </FormGroupComponent>
                                <button type="button" @click="editInput(key4, getClass(value4), row_key, keyx)">Edit Input</button>
                                <button type="button" @click="deleteInput(key4, getClass(value4), row_key, keyx)"><i  class="fa fa-trash"></i></button>
                            </span>
                        </div>
                    </div>
                    <div v-else>
                        <button type="button" @click="deleteRow(row_key)"><i  class="fa fa-trash"></i></button>
                        <hr/>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <input type="text" class="form-control" v-model="panel_name" placeholder="Panel Name" />
            <button type="button" @click="add">Add Panel</button>
        </div>
        <div class="modal fade" id="renameModal"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Rename Panel</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <input type="text" class="form-control" v-model="panel_rename" placeholder="Panel Name" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" @click="rename(selected_panel_key)" class="btn btn-primary">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="inputModal"  role="dialog" aria-labelledby="inputModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="inputModalLabel">Add Input</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group m-form__group">
                            <label>
                                Input type
                            </label>
                            <select class="form-control" v-model="form.type" v-on:change="initRepeater">
                                <option value="text">Text</option>
                                <option value="textarea">Textarea</option>
                                <option value="select">Select</option>
                                <option value="radio">Radio</option>
                                <option value="checkbox">Checkbox</option>
                                <option value="file">File</option>
                            </select>
                            <span class="m-form__help">
                                       You can select the input type.
                                    </span>
                        </div>
                        <div class="form-group m-form__group">
                            <label>
                                Name
                            </label>
                            <input type="text" class="form-control m-input" v-model="form.name">
                            <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                        </div>
                        <div class="form-group m-form__group">
                            <label>
                                Label
                            </label>
                            <input type="text" class="form-control m-input" v-model="form.label">
                            <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                        </div>
                        <div class="form-group m-form__group">
                            <label>
                                View Style
                            </label>
                            <select class="form-control" v-model="form.viewStyle">
                                <option value="1">Label up to Input</option>
                                <option value="2">Label left to Input</option>
                            </select>
                            <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label>
                                        Input class
                                    </label>
                                    <input type="text" class="form-control m-input" v-model="form.class">
                                    <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group m-form__group">
                                    <label>
                                        Input ID
                                    </label>
                                    <input type="text" class="form-control m-input" v-model="form.id">
                                    <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group m-form__group">
                            <label>
                                Input help text
                            </label>
                            <input type="text" class="form-control m-input" v-model="form.helpText">
                            <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                        </div>
                        <template v-if="(form.type == 'checkbox' || form.type == 'select' || form.type == 'radio')">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group m-form__group">
                                        <label>
                                            Select, Radio, Checkbox Model use
                                        </label>
                                        <select class="form-control" v-model="form.modelOption">
                                            <option v-for="mIt in models" v-bind:key="mIt">{{mIt}}</option>
                                        </select>
                                        <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group m-form__group">
                                        <label>
                                            Select connection Type
                                        </label>
                                        <select class="form-control" v-model="form.connectionName">
                                            <option value="belongsto">One to Many Inverse</option>
                                            <option value="belongstomany">Many to Many</option>
                                            <option value="hasmany">One to Many</option>
                                            <option value="hasone">One to One</option>
                                        </select>
                                        <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group m-form__group">
                                        <label>
                                            Foreign Key
                                        </label>
                                        <input type="text" class="form-control" v-model="form.key1" />
                                        <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group m-form__group">
                                        <label>
                                            Local Key
                                        </label>
                                        <input type="text" class="form-control" v-model="form.key2" />
                                        <span class="m-form__help">
                                       We'll never share your email with anyone else.
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="(form.type == 'checkbox' || form.type == 'select' || form.type == 'radio')">
                            <div class="form-group  m-form__group row">
                                <div class="col-lg-10" v-for="(option, key, index) in options" v-bind:key="index">
                                    <div class="form-group m-form__group row align-items-center">
                                        <div class="col-md-5">
                                            <div class="m-form__group m-form__group--inline">
                                                <div class="m-form__label">
                                                    <label>
                                                        Option Name:
                                                    </label>
                                                </div>
                                                <div class="m-form__control">
                                                    <input type="text" class="form-control m-input" v-model="option.value">
                                                </div>
                                            </div>
                                            <div class="d-md-none m--margin-bottom-10"></div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="m-form__group m-form__group--inline">
                                                <div class="m-form__label">
                                                    <label class="m-label m-label--single">
                                                        Option Value:
                                                    </label>
                                                </div>
                                                <div class="m-form__control">
                                                    <input type="text" class="form-control m-input" v-model="option.key">
                                                </div>
                                            </div>
                                            <div class="d-md-none m--margin-bottom-10"></div>
                                        </div>
                                        <div class="col-md-2">
                                            <div  class="btn-sm btn btn-danger m-btn m-btn--icon m-btn--pill" @click="deleteRepeater(repeat)">
                                                <span>
                                                   <i class="la la-trash-o"></i>
                                                   <span>
                                                      Delete
                                                   </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-form__group form-group row">
                                <label class="col-lg-2 col-form-label"></label>
                                <div class="col-lg-4">
                                    <div class="btn btn btn-sm btn-brand m-btn m-btn--icon m-btn--pill m-btn--wide" @click="repeaterCreate">
                                          <span>
                                             <i class="la la-plus"></i>
                                             <span>
                                                Add
                                             </span>
                                          </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" @click="addInputToColl()" class="btn btn-primary">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import FormGroupComponent from '../form/FormGroupComponent'

export default {
  name: 'Builder',
  data () {
    return {
      panel_name: '',
      panel_rename: '',
      selected_panel_key: 0,
      type: 'text',
      input_type: '',
      active_coll: '',
      active_row: '',
      active_class: '',
      options: [],
      isInputEdit: false,
      inputIndex: 0,
      form: {},
      tempMsg: '',
      inputs: {},
      errorMessage: '',
      hasDanger: ''
    }
  },
  components: {
    FormGroupComponent,
    draggable
  },
  props: {
    panels: {
      type: Object,
      required: true
    },
    active_panel: {
      required: true
    },
    models: {
      type: Array,
      required: true
    }
  },
  mounted: function () {
    this.resetForm()
  },
  watch: {
    'form.name': {
      handler (val) {
        if (val !== '' && val !== undefined) {
          this.form.id = 'form-' + val
          this.form.name = this.form.name.toLowerCase()
        }
      },
      deep: true
    }
  },
  methods: {
    slugify: function (val) {
      let p = val.split(' ').join('_')
      return p
    },
    resetForm: function () {
      this.form = {}
      this.options = []
      this.form.type = 'text'
      this.form.viewStyle = 1
      this.form.option_names = []
      this.form.option_values = []
    },
    editInput: function (key, acClass, row, index) {
      this.resetForm()
      this.isInputEdit = true
      let inputs = this.panels[this.active_panel][this.active_row].row[this.active_coll][this.active_class][index]

      this.form.type = inputs.type
      this.form.name = inputs.name
      this.form.viewStyle = inputs.viewStyle
      this.form.label = inputs.label
      this.form.helpText = inputs.helpText
      this.form.modelOption = inputs.modelOption
      this.form.class = inputs.class
      this.form.id = inputs.id
      this.options = this.createObject(inputs.options)
      this.inputIndex = index
      window.$('#inputModal').modal('show')
      this.updateUi()
    },
    deleteInput: function (key, acClass, row, index) {
      let self = this
      window.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: !0,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: !0
      }).then(function (e) {
        if (e.value) {
          self.panels[self.active_panel][self.active_row].row[self.active_coll][self.active_class].splice(index)
          self.updateUi()
          window.swal('Deleted!', 'Input has been deleted.', 'success')
        }
      })
    },
    repeaterCreate: function () {
      this.options.push({key: '', value: ''})
    },
    deleteRepeater: function (key) {
      this.options.splice(key, 1)
    },
    createArray: function (items) {
      let arr = {}

      for (let it in items) {
        arr[items[it].key] = items[it].value
      }

      return arr
    },
    createObject: function (items) {
      let arr = []

      for (let it in items) {
        arr.push({key: it, value: items[it]})
      }

      return arr
    },
    addInputToColl: function () {
      let obj = {}
      obj.name = this.form.name
      obj.label = this.form.label
      obj.type = this.form.type
      obj.class = this.form.class
      obj.id = this.form.id
      obj.helpText = this.form.helpText
      obj.modelOption = this.form.modelOption
      obj.options = this.createArray(this.options)
      obj.checkboxes = obj.options
      obj.radios = obj.options
      obj.errorMessage = ''
      obj.viewStyle = this.form.viewStyle

      this.inputs[obj.name] = obj.name

      if (this.isInputEdit === false) {
        this.panels[this.active_panel][this.active_row].row[this.active_coll][this.active_class].push(obj)
      } else {
        this.panels[this.active_panel][this.active_row].row[this.active_coll][this.active_class][this.inputIndex] = obj
      }
      window.$('#inputModal').modal('hide')
      this.resetForm()
      this.updateUi()
    },
    initRepeater: function () {
      this.input_type = this.form.type
      this.updateUi()
    },
    setActivePanel: function (key) {
      this.active_panel = key
      this.$emit('setActivePanel', key)
    },
    getRow: function (items) {
      let arr = []

      items.map(function (value, key) {
        if (value.row !== undefined) {
          arr.push(value.row)
        } else {
          arr.push({'break': 1})
        }
      })

      return arr
    },
    getElements: function (items) {
      return items[this.getClass(items)]
    },
    getClass: function (item) {
      for (let it in item) {
        return it
      }
    },
    add: function () {
      this.panels[this.panel_name] = []
      if (this.active_panel === '1') {
        this.setActivePanel(this.panel_name)
      }
      this.panel_name = ''
      this.updateUi()
    },
    rename: function (key) {
      this.panels[key].name = this.panel_rename
      this.setActivePanel(this.panel_rename)
      this.panel_rename = ''
      this.updateUi()
      window.$('#renameModal').modal('hide')
    },
    renameModal: function (key) {
      this.selected_panel_key = key
      this.updateUi()
      window.$('#renameModal').modal('show')
    },
    addRow: function () {
      this.panels[this.active_panel].push({'row': []})
      this.updateUi()
    },
    deleteCol: function (key, row) {
      let self = this
      window.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: !0,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: !0
      }).then(function (e) {
        if (e.value) {
          self.panels[self.active_panel][row].row.splice(key, 1)
          self.updateUi()
          window.swal('Deleted!', 'Column has been deleted.', 'success')
        }
      })
    },
    deleteRow: function (key) {
      let self = this
      window.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: !0,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: !0
      }).then(function (e) {
        if (e.value) {
          self.panels[self.active_panel].splice(key, 1)
          self.updateUi()
          window.swal('Deleted!', 'Row has been deleted.', 'success')
        }
      })
    },
    addBreak: function () {
      this.panels[this.active_panel].push({'break': 1})
      this.updateUi()
    },
    addCol: function (num, row) {
      let obj = {}
      obj[num] = []
      this.panels[this.active_panel][row].row.push(obj)
      this.updateUi()
    },
    addInput: function (key, acClass, row) {
      this.resetForm()
      this.isInputEdit = false
      this.active_coll = key
      this.active_row = row
      this.active_class = acClass

      this.form.class = 'form-control'

      this.updateUi()
      window.$('#inputModal').modal('show')
    },
    updateUi: function () {
      this.panel_name = '.'
      this.panel_name = ''
      this.$emit('updatePanel', this.panels)
      this.$emit('updateInputs', this.inputs)
    },
    deletePanel: function (key) {
      let self = this
      window.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: !0,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: !0
      }).then(function (e) {
        if (e.value) {
          self.panels.splice(key, 1)
          self.updateUi()
          window.swal('Deleted!', 'Panel has been deleted.', 'success')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/module/Builder.vue